import React from "react";
import { LinearProgress } from "@totalsoft/rocket-ui";

function WrappedLinearProgress() {
  return <LinearProgress color="primary" sx={{ "&.MuiLinearProgress-root": { mb: 0, borderRadius: "100vw" } }} />;
}

export default WrappedLinearProgress;
